import { createDefaultText } from './text';
import type { BookmarkEndElement, BookmarkStartElement } from '../types';

/** Word rejects bookmark names longer than this. */
export const MAX_BOOKMARK_NAME_LENGTH = 40;

export function createBookmarkStart(markerId: number, name: string): BookmarkStartElement {
  return {
    children: [createDefaultText()],
    markerId,
    name,
    suggestedEdits: [],
    type: 'bookmarkStart',
  };
}

export function createBookmarkEnd(markerId: number): BookmarkEndElement {
  return {
    children: [createDefaultText()],
    markerId,
    suggestedEdits: [],
    type: 'bookmarkEnd',
  };
}

/**
 * Word-style internal bookmarks (e.g. `_Ref…`, `_Toc…`, `_Hlk…`, `_top`) have
 * names starting with an underscore. They are auto-created for cross references,
 * tables of contents, and hyperlinks, and are hidden from the user
 */
export function isHiddenBookmarkName(name: string): boolean {
  return name.startsWith('_');
}

/**
 * Check if a user may name a bookmark `name`. As in Word, the name must start with a letter and
 * contain only letters, numbers and underscores, so users cannot create hidden bookmarks.
 */
export function getIsValidBookmarkName(name: string): boolean {
  return name.length <= MAX_BOOKMARK_NAME_LENGTH && /^\p{L}[\p{L}\p{N}_]*$/u.test(name);
}

/** Check if two bookmark names refer to the same bookmark. As in Word, case does not matter. */
export function getIsSameBookmarkName(a: string, b: string): boolean {
  return a.toLowerCase() === b.toLowerCase();
}
